import React from "react";
import api from "../../api/schedule";
import {schedData} from "../ScheduleList/tempdata.js"

const initialData = {
  scheduleMain: schedData[0],
  scheduleOrg: null
};

export default function useScheduleView() {
  const [scheduleData, setSchedulesData_] = React.useState(initialData);

  const setSchedulesData = newData => {
    const newSchedulesData = {
      ...scheduleData,
      ...newData
    };

    setSchedulesData_(newSchedulesData);
  };

  function getSchedule(id) {
    setSchedulesData({
      scheduleMain: schedData[0],
      scheduleOrg: null
    });
    /*Promise.all([
      api.getScheduleMainInfo(id)
    ]).then(([schedInfo, schedOrgInfo]) => {
      setSchedulesData({
        scheduleMain: schedInfo.data,
        scheduleOrg: schedOrgInfo.data
      });
    });*/
  }

  return { scheduleData, setSchedulesData, getSchedule };
}
